<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Acknowledgements</p>
<p class="noindent">I would like to thank all the members of the Cosmic Society of Paranormal Investigation for their endless encouragement and contributions in the writing of this book. Especially: Rich and Cardy Keegan, Mark Larsen, Margaret Scholz, Matt and Chris Nickerl, Leanne and A.J. Root, Brendan and Charlene Logan, Chadi Noujaim and Nicole Donzello and Jenna Santorelli. I owe more than words to Brian Jones for countless hours of writing and editing with me and to my children Chloe and Justin for bearing with me (or without me as the case may have been) while I was immersed in completing this publication. Thanks also go to my best friend, Michele Polvay, who made sure we stayed fed throughout.</p>
<p class="image"><img alt="img" src="images/page009_01.jpg"/></p>
<p class="indent">Special thanks also to Faye Ringel, PhD, professor of English and Humanities at the U.S. Coast Guard Academy; Dale Plummer, town historian, Norwich, Connecticut; Patricia Sweeney, librarian of Derby Neck Library; Ann Tate, librarian of the Stonington Historical Society; Bev York of the Windham Textile and History Museum; Bob Falcone and Adam Lippman for their photo help.</p>
<p class="indent">The stories within wouldn’t have been told without the help of Betty Cordellos of Haunted Connecticut Tours, the owners and docents of all of the haunted locations included herein and the voices of the spirits themselves, who definitely made themselves heard and guided my hand to information in order to get their respective stories straight, most times around 2:00 a.m.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?79c992e0